import React from 'react'

import ReactModal from 'react-modal'

import styles from './add-users-to-content.module.scss'
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';
import PerfectScrollbar from 'react-perfect-scrollbar';

const AddUsersToContentPopUp = (
    {
        isOpen,
        closePopUp,
        contentTitle,
        addMembersPopUpID,
        SearchComp,
        AddActionfnComp,
        MemberSelection,
        TableSection,
        EmptyAndLoadingComp,
        PaginationComp
    }:
        {
            isOpen: boolean
            closePopUp: () => void
            contentTitle: string
            addMembersPopUpID: string
            SearchComp: JSX.Element
            AddActionfnComp: JSX.Element | null
            MemberSelection: JSX.Element
            TableSection: JSX.Element
            EmptyAndLoadingComp: JSX.Element
            PaginationComp: JSX.Element
        }
) => {

    // const _tabWrapElHeight = useAdminContainerHeight();
    // const tabWrapElHeight = (addMembersPopUpID === 'add-members-to-group-dm') ? 880 : '90%';

    // const popUpheight = window.innerWidth <= 1400
    //     ? `${tabWrapElHeight - 300}px`
    //     : window.innerWidth <= 1600
    //         ? `${tabWrapElHeight - 130}px`
    //         : `${tabWrapElHeight}px`;

    // const popUpInnerheight = window.innerWidth <= 1400
    //     ? `${tabWrapElHeight - 440}px`
    //     : window.innerWidth <= 1600
    //         ? `${tabWrapElHeight - 270}px`
    //         : `${tabWrapElHeight - 140}px`;


    return (
        <ReactModal
            isOpen={isOpen}
            className={styles.AddUsersToContentBody}
            style={{
                content: {
                    maxHeight: "85vh", // Keeps it from covering the full height
                    margin: "auto",
                    overflow: "hidden", // Ensures only the inner content scrolls
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 999,
                }
            }}
            id={addMembersPopUpID}
        >
            <div className={styles.AddUsersToContentHeader}>
                <h1>
                    {contentTitle}
                </h1>
                <span
                    onClick={closePopUp}
                    className={styles.ClosePopUp}
                >
                    <CloseIcon />
                </span>
            </div>

            <div className={`${styles.AddUsersToContentActions} `}>
                <div className={`${styles.AddUsersToContentsearch} ${AddActionfnComp === null ? styles.AddUsersToContentsearch__withNoAddActionfn : ''}`}>
                    {/* search bar child*/}
                    {SearchComp}
                </div>
                <div className={styles.AddUsersToContentBtn}>
                    {/* AddActionfn child */}
                    {AddActionfnComp}
                </div>
            </div>

            {/* checkbox selection header */}
            <div className={styles.AddUsersToContentSelection}>
                {MemberSelection}
            </div>


            {/* table section */}
            <PerfectScrollbar
                style={{
                    maxHeight: "55vh", // Ensures it does not take up too much space
                    overflowY: "auto", // Enables scrolling
                    minHeight: "50vh"
                }}
                className={styles.AddUsersToContentList}
                id='add-users-to-content-list'
                options={{
                    wheelPropagation: false,
                }}
            >
                <div>
                    {TableSection}
                </div>
                {EmptyAndLoadingComp}
            </PerfectScrollbar>
            {PaginationComp}
        </ReactModal >
    )
}

export default AddUsersToContentPopUp